<template>
    <div v-if="item" class="image-wrapper">
        <progressive-img :src="item.image"
            ref="progressiveImage"
            :alt="item.description"
            class="no-highlight progressive-menu-img"
            @onLoad="loadImage" />
        <div class="img-pricing-overlay" v-if="showPrice">
            <BaseButton
                :classNames="['button--modifier', 'menu-img-order-btn']"
                title="Order Now"/>
            <p class="img-price" v-if="showPrice">
				<span class="text-outline"><span class="dollar-sign">$</span>{{getBundlePrice()}}</span>
            </p>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { MENU_OPTION_EXCEPTIONS } from "@/stores/defs";
import Formatter from "@/utils/Formatter";
import { ResponsiveMixin } from "vue-responsive-components";

export default {
	mixins: [ResponsiveMixin],
	breakpoints: {
		compact: (el) => {
			return el.width <= 180;
		},
	},
    props: {
        item: {
            type: Object,
            default: () => {
                return {};
            }
        },
    },
    computed: {
        ...mapGetters({
            allExceptions : MENU_OPTION_EXCEPTIONS.GET_ALL,
            exceptionsForItem: MENU_OPTION_EXCEPTIONS.GET_FOR_ITEM
        }),
        showPrice() {
        // TODO: for now do this for all bundles. Will become flag in future
			const compactView = this.el.is.compact;
			return (this.item && this.item.bundle && !compactView);
		},
    },
    methods: {
        adjustImage() {
            const progressiveImage = this.$refs.progressiveImage;
            const image = progressiveImage.$refs.main;
            const notBundle = (this.item && !this.item.bundle)
            if (notBundle) {
                image.style.maxHeight = "174px";
                image.style.objectFit = "cover";
            }
        },
        loadImage(imageUrl) {
            this.adjustImage();
        },
        getBundlePrice() {
            let price = 0;
            if (this.item && this.item.bundle) {
                const discount = this.item.discount;
                if (discount.type == 2) {
                    price =  discount.amount;
                }
                
            }
            return Formatter.centsToDollars(price);
        }
	},
};
</script>

<style lang="scss" scoped>
	@import 'globalStyles';
	@import 'commonStyle/menuCard';
    
    .image-wrapper {
        position: relative;
    }
    .progressive-menu-img {
        display: block;
    }

    .img-pricing-overlay {
        position: absolute;
        width: 100%;
		bottom: 4px;
        text-align: right;
        z-index: 2;
        
        .img-price {
            color: #000000;
            font-weight: bold;
            font-size: 1.5rem;
            padding-right: 2%;
        }
	}
	.text-outline {
		text-shadow: -1px 1px 0px $menu_card_name_background,
			1px -1px 0px $menu_card_name_background,
			1px 1px 0px $menu_card_name_background,
			-1px -1px 0px $menu_card_name_background;
	}
	.dollar-sign {
		position: relative;
		top: -2px;
		right: 1px;
		font-size: 0.7em;
	}
    
    @include mobile {
        .img-pricing-overlay {
            .img-price {
                font-size: 1.2rem;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/menu/MenuItem/MenuItemImage.vue